export const GA_API = 'https://www.googletagmanager.com/gtag/js';
